import { Dates, NOW, REGEX } from 'context/DateProvider/DateProvider';
import { convertNowToISO } from 'context/DateProvider/utils/convertNowToISO';

export type DateTimeRangeValidationResponse = {
  newDates: Dates;
  message: string;
};

export const validateDateTimeRange = (newDates: Dates): DateTimeRangeValidationResponse => {
  const { from, to } = newDates;
  let message = '';

  if (from && to) {
    if (from === to) {
      message = 'From and to date values are the same';
    }

    const start = new Date(convertNowToISO(from));
    const end = new Date(convertNowToISO(to));

    const fromMatchHour = from.match(REGEX);
    const fromMatchDate = from.match(/^\d{4}-\d{2}-\d{2}.*$/);
    const toMatchHour = to.match(REGEX);
    const toMatchDate = to.match(/^\d{4}-\d{2}-\d{2}.*$/);

    if (start > end) {
      message = 'From is after to';
    } else if (from !== NOW && !fromMatchHour && !fromMatchDate) {
      message = 'The from is invalid';
    } else if (to !== NOW && !toMatchHour && !toMatchDate) {
      message = 'The to is invalid';
    }
  }
  return { newDates, message };
};
